module.exports = __webpack_public_path__ + "img/Logo_BMW.c99558d0.svg";